/**
 * Контент блога antologia.tech
 * slug = URL: /blog/:slug
 */

import {
  HARNESS_BLOG_SLUG,
  harnessBlogListItem,
  harnessBlogPost,
} from './blogPostHarnessAiAgents';

export const allPosts = [
  {
    slug: HARNESS_BLOG_SLUG,
    title: 'Harness для AI-агентов: on-premise, облако, производительность',
  },
  {
    slug: 'klassifikaciya-ii-reshenij-chat-rag-agent-harness',
    title: 'Классификация ИИ-решений: от чат-бота до harness',
  },
  {
    slug: 'ai-efficiency-business-russia',
    title: 'От парового двигателя до AI',
  },
];

export const blogList = [
  harnessBlogListItem,
  {
    slug: 'klassifikaciya-ii-reshenij-chat-rag-agent-harness',
    title:
      'Классификация ИИ-решений: от чат-бота до harness. Что выбирать в B2B',
    description:
      'Шесть типов ИИ-систем: чат с LLM, тулы, Deep Research, RAG, агент и harness. Как отличить, что внедрять и зачем руководителю смотреть на архитектуру, а не на название вендора.',
    image: '/images/blog/difficult.png',
    date: '16 мая 2026',
    category: 'AI для бизнеса',
    readTime: '12 мин',
  },
  {
    slug: 'ai-efficiency-business-russia',
    title:
      'От парового двигателя до AI: как технологии меняют эффективность бизнеса в России',
    description:
      'Анализ технологической революции AI в России: прогнозы академика РАН Роберта Нигматулина о 35 годах бедности и мнение основателя amoCRM.',
    image: '/images/ai-efficiency-business-russia.png',
    date: '3 мая 2026',
    category: 'AI для бизнеса',
    readTime: '8 мин',
  },
];

const CHECKLIST_PATH = '/ready-for-ai';

export const blogPosts = {
  'harness-ai-agenty-chto-eto-vnedrenie-on-prem-oblako': harnessBlogPost,

  'klassifikaciya-ii-reshenij-chat-rag-agent-harness': {
    title:
      'Классификация ИИ-решений: от чат-бота до harness. Что выбирать в B2B.',
    seoTitle:
      'Классификация ИИ-решений для бизнеса: чат, RAG, агент, harness | Блог Антология',
    description:
      'Шесть типов ИИ-систем: чат с LLM, тулы, Deep Research, RAG, агент и harness. Как отличить, что внедрять и зачем руководителю смотреть на архитектуру, а не на название вендора.',
    keywords:
      'классификация ИИ решений, чатбот и агент отличие, RAG для бизнеса, harness engineering, deep research ИИ, типы ИИ систем, внедрение ИИ B2B, ИИ для бизнеса',
    date: '16 мая 2026',
    category: 'AI для бизнеса',
    readTime: '12 мин',
    author: 'Сергей Успенский',
    image: '/images/blog/difficult.png',
    imageAlt:
      'Сводная таблица: шесть типов ИИ-систем от чата с LLM до harness - память, тулы, логика, сложность внедрения',
    canonicalPath: '/blog/klassifikaciya-ii-reshenij-chat-rag-agent-harness',
    datePublishedISO: '2026-05-16',
    dateModifiedISO: '2026-05-16',
    keyTakeaways: [
      'В B2B полезно различать шесть классов ИИ: чат с LLM, LLM с тулами, Deep Research, RAG, агент и harness — у каждого свой риск и срок пилота.',
      'Чат-бот без доступа к вашим системам не заменяет автоматизацию процесса end-to-end.',
      'RAG опирается на качество индекса документов; устаревшие регламенты дают уверенные, но неверные ответы.',
      'Агент и harness требуют владельца процесса, лимитов, логов и политики данных.',
      'В переговорах с подрядчиком спрашивайте уровень из классификации, а не только бренд продукта.',
    ],
    intro:
      'На встречах про ИИ одно и то же повторяется: простой чат в браузере называют агентом, агента RAGом, RAG называют волшебной базой знаний, которая сама всё починит. Путаница нормальна, границы между типами систем размыты, вендоры смешивают маркетинговые ярлыки, а продукты за полгода подтягивают функции соседних категорий.',
    intro2:
      'Ниже рабочая классификация из шести уровней. Это не академическая таксономия и не рейтинг вендоров. Это карта, чтобы договориться в команде, что мы покупаем или строим и какой риск за этим стоит.',
    sections: [
      {
        title: 'Для кого эта статья',
        paragraphs: [
          'COO, операционные директора, руководители ИТ и цифровой трансформации в B2B (РФ, компании от ~100 сотрудников, в первую очередь торговля и IT).',
          'Если на совещании звучат чат-бот, агент и RAG вперемешку - вы не обязаны разбираться в каждом фреймворке. Достаточно понимать класс системы, что она умеет, из чего состоит и какую задачу закрывает. Тогда проще выбрать пилот, задать вопросы интегратору и не платить за уровень сложности, который вам пока не нужен.',
        ],
      },
      {
        title: 'Зачем операционке вообще различать типы систем',
        paragraphs: [
          'ИТ часто смотрит на модель и API. Операционке важнее другое, предсказуемость. Например детерминированный FAQ на документах ведёт себя иначе, чем агент, который сам перепланирует задачу. Ответственность, кто отвечает, если система ушла во внешний API или отправила письмо от имени компании. Стоимость владения harness и агенты требуют обвязки, логов, лимитов. Чат с LLM в основном лицензии и политики данных, срок пилота RAG на Confluence за неделю и агент с доступом к прод-среде - это разные вселенные по согласованиям.',
        ],
        checklistCta: true,
      },
      {
        title: 'Шесть типов ИИ-решений',
        subtitle: '1. Чат с LLM (чат-бот)',
        paragraphs: [
          'Это Веб или мобильный интерфейс с языковыми моделями. Пользователь пишет, а модель отвечает. История сессии даёт краткосрочную память, системный промпт задаёт тон и роль ассистента.',
          'Из чего состоит: LLM + инструкция + контекст диалога. Инструментов нет или они спрятаны внутри продукта.',
          'Какие задачи закрывает: черновики текстов, объяснения, мозговой штурм, обучение сотрудников, быстрые ответы без привязки к корпоративным данным.',
          'Примеры: ChatGPT, Claude, GigaChat, Алиса в браузере, локальный Open WebUI, LibreChat.',
          'Ограничение для бизнеса: без подключения к вашим системам и документам это не корпоративная память компании и не автоматизация процесса end-to-end.',
        ],
      },
      {
        subtitle: '2. LLM с инструментами (роутер)',
        paragraphs: [
          'По сути тот же чат с LLM, но оркестратор по запросу вызывает инструменты, например погода, калькулятор, поиск, отправка письма и подставляет результат в контекст модели.',
          'Решение, какой инструмент дернуть, часто одношаговое, без явного многошагового плана и переоценки плана по ходу работы.',
          'Отличие от агента: мало рефлексии и пересборки плана. Система не спрашивает себя час спустя, цель достигнута или нужен другой путь.',
        ],
      },
      {
        subtitle: '3. Deep Search / Deep Research',
        paragraphs: [
          'Система исследует открытый мир, например веб, индекс, API новостей в несколько шагов: уточнить запрос, составить план подзапросов, в цикле искать и читать источники, собрать отчёт и проверить полноту.',
          'Задачи: рыночная аналитика, обзор регуляторики, конкуренты, due diligence по открытым источникам.',
          'Для B2B: полезно на этапе разведки, слабее как замена внутреннего RAG по закрытым данным без отдельной настройки границ доступа.',
        ],
      },
      {
        subtitle: '4. RAG (Retrieval-Augmented Generation)',
        paragraphs: [
          'Ответы опираются на базу знаний, векторное хранилище, Confluence, PDF, тикеты. Ретривер вытаскивает релевантные фрагменты, LLM синтезирует ответ с опорой на контекст.',
          'Задачи: FAQ, онбордининг, поиск по внутренней документации, поддержка первой линии по регламентам.',
          'Почему не путать с агентом, даже продвинутый RAG обычно детерминированнее, один-два прохода retrieve + generate.',
          'Риски: качество ответа = качество индекса и прав доступа. Устаревшие регламенты дают уверенные, но неверные ответы.',
        ],
      },
      {
        subtitle: '5. Агент',
        paragraphs: [
          'Недетерминированная система сама ставит подзадачи, вызывает тулы, оценивает результат. В инструкции зашиты планирование, циклы plan-act-observe и критерии успеха.',
          'Задачи: многошаговая работа с неполной постановкой: разработка, анализ пакета файлов, сценарии, где путь к результату заранее не расписан.',
          'Для B2B: высокий потенциал и высокий операционный риск, нужны владелец процесса, политика данных и обвязка.',
        ],
      },
      {
        subtitle: '6. Harness',
        paragraphs: [
          'Не ещё более умная модель, а инфраструктура вокруг агента: песочница, лимиты, ретраи, очередь задач, логи, верификация артефактов, долгосрочная память, MCP/skills, human-in-the-loop.',
          'Задачи: промышленная эксплуатация, когда агентов не один, а поток задач, и нужны аудит, откат и согласование человеком.',
          'Про harness engineering: в 2025-2026 вендоры всё чаще отделяют инженерию обвязки от выбора модели. Цифры из чужих кейсов в ваш пилот не переносим, смотрим на свой контур.',
        ],
      },
      {
        title: 'Сводная таблица: шесть типов ИИ-систем',
        paragraphs: [
          'Сравнение по памяти, инструментам, типичной логике и сложности внедрения - наглядно на схеме ниже.',
        ],
        image: '/images/blog/difficult.png',
        imageAlt:
          'Таблица классификации ИИ-решений: чат с LLM, LLM с тулами, Deep Research, RAG, агент, harness',
      },
      {
        title: 'Иерархия сложности (рабочая, не догма)',
        paragraphs: [
          'Упрощённо, снизу вверх по возможностям и требованиям к зрелости процессов: Harness > Агент > RAG | Deep Research > LLM с тулами > Чат с LLM.',
          'Вертикально каждый уровень обычно включает элементы нижних. Горизонтально RAG и Deep Research не строго сравнимы, одно про ваши документы, другое про открытый мир.',
          'Границы размыты. ChatGPT сегодня умеет и поиск, и файлы, и режим исследования в переговорах с подрядчиком спрашивайте не бренд, а какой уровень из таблицы вы покупаете и что входит в SLA.',
        ],
      },
      {
        title: 'Что спросить на закупке или пилоте',
        items: [
          'Какой тип из шести вы внедряете и можно ли отключить лишние уровни на старте?',
          'Где хранятся данные и какие API уходят наружу?',
          'Кто владелец эффекта в операции, не только в ИТ?',
          'Как измерим успех пилота - один показатель, не десять демо-метрик?',
          'Что после пилота - поддержка, интеграции, human-in-the-loop?',
        ],
        checklistCta: true,
      },
      {
        title: 'Частые ошибки (без стыда, по делу)',
        items: [
          'Назвать чат агентом и ждать автоматизации процесса закупки.',
          'Взять RAG без актуализации базы знаний, получите уверенные галлюцинации в корпоративном тоне.',
          'Запустить агента без лимитов и логов, получите сюрприз в проде.',
          'Смешать Deep Research и внутренний комплаенс, открытый веб не заменяет согласованный контур данных.',
        ],
      },
    ],
    conclusion:
      'Классификация помогает говорить на одном языке с ИТ и интегратором. Перед пилотом полезно честно проверить готовность компании: данные, владелец процесса, интеграции. Если после самопроверки видно, что пилот возможен, но нужны рамки и цифры, напишите нам. Разберём формат внедрения и предоставим расчёт с менеджером без обещания фиксированного ROI до погружения в ваш контур.',
    conclusionWithChecklist: true,
    faq: [
      {
        question: 'Чем чат-бот отличается от ИИ-агента?',
        answer:
          'Чат отвечает в рамках сессии и промпта. Агент сам планирует шаги, вызывает инструменты и проверяет результат. Агент недетерминированнее и требует сильнее обвязки.',
      },
      {
        question: 'Что такое RAG простыми словами?',
        answer:
          'Модель отвечает, опираясь на найденные фрагменты вашей базы знаний, а не только на обучение. Подходит для FAQ и документации при дисциплине обновления источников.',
      },
      {
        question: 'Что такое harness в ИИ?',
        answer:
          'Инфраструктура вокруг агента: безопасность, лимиты, очереди, логи, проверки, участие человека. Без harness агент остаётся демо, а не производственным контуром.',
      },
      {
        question: 'Нужен ли бизнесу сразу агент?',
        answer:
          'Часто нет. Многим хватает RAG или чата с тулами на одном процессе. Агент и harness оправданы, когда задача многошаговая и есть владелец риска в операции.',
      },
      {
        question: 'Deep Research и RAG - одно и то же?',
        answer:
          'Нет. Deep Research ищет и синтезирует по открытым источникам в несколько шагов. RAG работает с вашим индексом внутренних (или выделенных) документов.',
      },
    ],
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline:
          'Классификация ИИ-решений: от чат-бота до harness. Что выбирать в B2B.',
        description:
          'Шесть типов ИИ-систем: чат с LLM, тулы, Deep Research, RAG, агент и harness. Как отличить, что внедрять в B2B.',
        author: { '@type': 'Person', name: 'Сергей Успенский' },
        publisher: {
          '@type': 'Organization',
          name: 'Антология',
          logo: {
            '@type': 'ImageObject',
            url: 'https://antologia.tech/logo.png',
          },
        },
        datePublished: '2026-05-16',
        dateModified: '2026-05-16',
        image: 'https://antologia.tech/images/blog/difficult.png',
        keywords:
          'классификация ИИ решений, RAG для бизнеса, harness engineering, внедрение ИИ B2B',
        articleSection: 'AI для бизнеса',
        inLanguage: 'ru-RU',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id':
            'https://antologia.tech/blog/klassifikaciya-ii-reshenij-chat-rag-agent-harness',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Чем чат-бот отличается от ИИ-агента?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Чат отвечает в рамках сессии и промпта. Агент сам планирует шаги, вызывает инструменты и проверяет результат.',
            },
          },
          {
            '@type': 'Question',
            name: 'Что такое RAG простыми словами?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Модель отвечает, опираясь на найденные фрагменты вашей базы знаний.',
            },
          },
          {
            '@type': 'Question',
            name: 'Что такое harness в ИИ?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Инфраструктура вокруг агента: безопасность, лимиты, очереди, логи, проверки, участие человека.',
            },
          },
          {
            '@type': 'Question',
            name: 'Нужен ли бизнесу сразу агент?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Часто нет. Многим хватает RAG или чата с тулами на одном процессе.',
            },
          },
          {
            '@type': 'Question',
            name: 'Deep Research и RAG - одно и то же?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Нет. Deep Research работает с открытыми источниками, RAG - с вашим индексом документов.',
            },
          },
        ],
      },
    ],
    checklistPath: CHECKLIST_PATH,
  },

  'ai-efficiency-business-russia': {
    title:
      'От парового двигателя до AI: как технологии меняют эффективность бизнеса.',
    seoTitle: 'От парового двигателя до AI | Блог Антология',
    description:
      'Анализ технологической революции AI в России: прогнозы академика РАН Роберта Нигматулина и мнение основателя amoCRM.',
    keywords:
      'AI для бизнеса, искусственный интеллект, технологическая революция, внедрение AI, бизнес-эффективность',
    date: '3 мая 2026',
    datePublishedISO: '2026-05-03',
    dateModifiedISO: '2026-05-03',
    canonicalPath: '/blog/ai-efficiency-business-russia',
    category: 'AI для бизнеса',
    readTime: '8 мин',
    author: 'Сергей Успенский',
    keyTakeaways: [
      'Технологические волны (пар, конвейер, компьютеры, AI) дают кратный рост эффективности; AI — следующий этап для белых воротничков.',
      'Для российского B2B разумно начинать с Copilot и ИИ-агентов на рутине, а не с максимально автономных систем.',
      'Команда с AI может быть в разы продуктивнее команды без него — при условии обучения и выбора процессов.',
      'Прогноз на 3 года: рост производительности 200–300% у компаний, которые внедряют AI системно.',
    ],
    disclaimer:
      'дисклеймер: мнения экспертов могут не совпадать с позицией автора.',
    image: '/images/ai-efficiency-business-russia.png',
    imageAlt: 'От парового двигателя до AI: эффективность бизнеса в России',
    sections: [
      {
        title: 'Вступление',
        content: `Российская экономика в настоящий момент находится на критическом рубеже. Академик РАН Роберт Нигматулин предупреждает о 35 годах бедности, если ничего не менять.

Данный материал о том, как технологии нейронных сетей и ИИ-агенты, могут помочь предпринимателям и бизнесу увеличить эффективность труда в своих коллективах.`,
      },
      {
        content: `И на этот счёт интересно мнение основателя amoCRM Михаила Токовинина, который утверждает: "Вы ещё даже не видели ничего — вы в интернете 1998 года".

Однако уже сегодня понятно, что нейронные сети значительно перестраивают текущие бизнес-процессы.`,
      },
      {
        content: `Здравствуй, уважаемый читатель. Эта статья займет примерно 8 минут времени на ее чтение.

За это время я дам вам краткую справку о том, каков был средний прирост эффективности труда за счёт технологий.`,
      },
      {
        title: 'История технологических прорывов',
        content:
          'Каждая технологическая революция начиналась с одной идеи: сделать то, что требовало много сил и времени - быстрее, дешевле, эффективнее.',
      },
      {
        title: 'Паровой двигатель',
        content:
          'Первая промышленная революция. Страны, которые первыми внедрили пар - Великобритания, Германия, США - на столетия обогнали остальной мир.',
        stats: [
          {
            label: 'Первые паровые машины (Папена, Ньюкомена)',
            value: '0,5–1% КПД',
          },
          {
            label: 'Современные паровые двигатели с конденсатором',
            value: '25–30% КПД',
          },
          {
            label: 'Паровые турбины на тепловых электростанциях',
            value: '30–42% КПД',
          },
          { label: 'Парогазовые установки', value: 'до 50–60% КПД' },
        ],
        note: 'Паровая технология позволила перейти от ручного труда к машинному производству.',
      },
      {
        title: 'Электричество и конвейер',
        content:
          'Генри Форд собрал автомобиль за 93 минуты. Появилось массовое производство.',
        stats: [
          { label: 'До конвейера: сборка одного магнето', value: '20 минут' },
          { label: 'После: магнето', value: '5 минут (рост в 4 раза)' },
          { label: 'До конвейера: сборка шасси', value: '12 часов 8 минут' },
          {
            label: 'После: шасси',
            value: '1 час 33 минуты (рост в 7,8 раз)',
          },
        ],
        note: 'Ключевое нововведение: рабочий оставался на месте, а продукт двигался к нему.',
      },
      {
        title: 'Компьютер и Интернет',
        content:
          'Информационные процессы перешли в цифровой мир. Географические границы исчезли.',
        stats: [
          {
            label: 'Рост производительности вычислительных систем (1850–2006)',
            value: '2 триллиона раз (2×10¹²)',
          },
          { label: 'Среднегодовой рост после 1945 года', value: '45% в год' },
        ],
        note: 'Парадокс Солоу: в 1970–1980-е рост производительности в США замедлился, несмотря на распространение компьютеров.',
      },
      {
        title: 'Искусственный интеллект',
        content:
          'Сейчас мы наблюдаем пятую технологическую революцию. AI способен понимать контекст, принимать решения, обучаться и действовать автономно.',
        stats: [
          { label: 'Рост производительности белых воротничков', value: '20–30% уже сейчас' },
          { label: 'Прогноз на 3 года', value: '200–300% роста производительности' },
        ],
        note: 'AI работает автономно, обучается на ваших данных и действует от вашего имени.',
      },
      {
        title: 'Где сейчас Россия: Нигматулин',
        content: 'Академик РАН Роберт Нигматулин привёл тревожные цифры:',
        quote:
          '35 лет бедности - это прогноз, если ничего не менять в экономической политике.',
        source: 'Академик РАН Роберт Нигматулин',
      },
      {
        title: 'Где сейчас AI в России: Токовинин',
        content: 'Основатель amoCRM Михаил Токовинин сказал про ранний период AI:',
        quote:
          'Вы в интернете образца 1998 года. Впереди ещё взлёт Google, падение Yahoo.',
        source: 'Основатель amoCRM Михаил Токовинин',
      },
      {
        title: 'Что такое Copilot и ИИ-агенты',
        content:
          'На текущий момент массовое распространение получили два класса систем: ассистенты (Copilot) и агенты (AI-agents).',
        definitions: [
          {
            term: 'Copilot',
            description:
              'Система, которая работает автономно, интегрируется в рабочие процессы, обучается на ваших данных.',
          },
          {
            term: 'ИИ-агент',
            description:
              'Автономная система для сложных многоэтапных задач с доступом к инструментам.',
          },
        ],
      },
      {
        title: 'Что изменится через 3 года',
        items: [
          'ИИ-ассистенты будут применяться сотрудниками повсеместно',
          'Предиктивная аналитика станет доступна каждому',
          'Интеллектуальная автоматизация документов',
          'Персонализация без затрат',
          'ИИ-агенты в каждом отделе',
        ],
      },
      {
        title: 'Инвестиции в ИИ сейчас',
        content:
          'История показывает: каждая технологическая революция проходила через фазу неокупаемости, прежде чем создать новую ценность.',
      },
      {
        title: 'Сравнительная таблица',
        content:
          'Те, кто внедрит AI, могут получить технологический прорыв. Команда с AI будет несопоставима по производительности с командой без него.',
        table: [
          { tech: 'Паровой двигатель', growth: 'В разы', period: '50+ лет' },
          { tech: 'Конвейер', growth: '4–8 раз', period: '10–20 лет' },
          { tech: 'Компьютеры', growth: '2 трлн раз (мощность)', period: '60 лет' },
          { tech: 'AI', growth: '200–300% прогноз', period: '3 года' },
        ],
      },
    ],
    conclusion:
      'Российский бизнес сейчас на переломе. Те, кто первыми научатся использовать ИИ-агентов, получат преимущество. Вопрос - останется ли ваш бизнес на рынке через 3–5 лет.',
    faq: [
      {
        question: 'Как внедрить ИИ в малый бизнес в России?',
        answer:
          'Начните с Copilot-систем для автоматизации рутинных задач: клиентская поддержка, аналитика, работа с CRM.',
      },
      {
        question: 'Какие ИИ-инструменты нужны малому бизнесу?',
        answer:
          'Copilot-ассистенты, ИИ-агенты, предиктивная аналитика, интеллектуальная автоматизация.',
      },
      {
        question: 'Сколько стоит внедрение AI в бизнес?',
        answer:
          'Стоимость варьируется от бесплатных до enterprise-решений. Начните с недорогих, оцените ROI.',
      },
      {
        question: 'Заменят ли ИИ сотрудников в России?',
        answer:
          'ИИ заменит рутинные задачи, но потребует новых навыков. Команда с AI будет эффективнее.',
      },
      {
        question: 'Прогнозы по AI для бизнеса на 2026 год?',
        answer:
          'Рост производительности на 200–300%. ИИ-агенты в каждом отделе как инструмент автоматизации.',
      },
    ],
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline:
          'От парового двигателя до AI: как технологии меняют эффективность бизнеса в России',
        description:
          'Анализ технологической революции AI в России: прогнозы академика РАН Роберта Нигматулина и мнение основателя amoCRM Михаила Токовинина о будущем бизнеса с ИИ.',
        author: { '@type': 'Person', name: 'Сергей Успенский' },
        publisher: {
          '@type': 'Organization',
          name: 'Антология',
          logo: {
            '@type': 'ImageObject',
            url: 'https://antologia.tech/logo.png',
          },
        },
        datePublished: '2026-05-03',
        dateModified: '2026-05-03',
        image: 'https://antologia.tech/images/ai-efficiency-business-russia.png',
        keywords:
          'AI для бизнеса Россия, внедрение ИИ, эффективность бизнеса, Copilot, ИИ-агенты',
        articleSection: 'AI для бизнеса',
        inLanguage: 'ru-RU',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://antologia.tech/blog/ai-efficiency-business-russia',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Как внедрить ИИ в малый бизнес в России?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Начните с Copilot-систем для автоматизации рутинных задач: клиентская поддержка, аналитика, работа с CRM.',
            },
          },
          {
            '@type': 'Question',
            name: 'Какие ИИ-инструменты нужны малому бизнесу?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Copilot-ассистенты, ИИ-агенты, предиктивная аналитика, интеллектуальная автоматизация.',
            },
          },
          {
            '@type': 'Question',
            name: 'Сколько стоит внедрение AI в бизнес?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Стоимость варьируется от бесплатных до enterprise-решений. Начните с недорогих, оцените ROI.',
            },
          },
          {
            '@type': 'Question',
            name: 'Заменят ли ИИ сотрудников в России?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'ИИ заменит рутинные задачи, но потребует новых навыков. Команда с AI будет эффективнее.',
            },
          },
          {
            '@type': 'Question',
            name: 'Прогнозы по AI для бизнеса на 2026 год?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Рост производительности на 200–300%. ИИ-агенты в каждом отделе как инструмент автоматизации.',
            },
          },
        ],
      },
    ],
    showSources: true,
    checklistPath: CHECKLIST_PATH,
  },
};
